export default {
    CADASTRAMENTO_ATUALIZACAO: 1,
    VISITA_PERIODICA: 2,
}